(function(){
const mega = document.querySelector('[data-moomori-mega]');
if(!mega) return;

const panels = [...mega.querySelectorAll('.moomori-mega__panel')];
if(!panels.length) return;

const open = (title) => {
panels.forEach(p => p.style.display = (p.dataset.megaPanel === title ? 'block' : 'none'));
};
const close = () => panels.forEach(p => p.style.display = 'none');

document.addEventListener('mouseover', (e) => {
const item = e.target.closest('.header__menu-item');
if(!item) return;
const title = item.textContent.trim();
const match = panels.some(p => p.dataset.megaPanel === title);
match ? open(title) : close();
});

mega.addEventListener('mouseleave', close);
document.addEventListener('keydown', (e) => { if(e.key === 'Escape') close(); });
})();
